import { render } from "./OdsSpinner.vue?vue&type=template&id=451a9641&scoped=true"
import script from "./OdsSpinner.vue?vue&type=script&lang=js"
export * from "./OdsSpinner.vue?vue&type=script&lang=js"

import "./OdsSpinner.vue?vue&type=style&index=0&id=451a9641&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451a9641"]])

export default __exports__